import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, formatErr } from "../../../../lib/api";
import { toast } from "sonner";
import { DetailField, SectionCard, StatusPill } from "./shared";
import { ACCOUNTING_BASE } from "./accountingNav";

export default function FinancialYearViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fy, setFy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/society/accounting/engine/financial-years/${id}`);
        setFy(res.data);
      } catch (err) {
        toast.error(formatErr(err, "Could not load this financial year"));
        navigate(`${ACCOUNTING_BASE}/financial-years`, { replace: true });
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) return <div className="text-sm text-[#6B7280]">Loading...</div>;
  if (!fy) return null;

  return (
    <div className="space-y-5">
      <div>
        <Link to={`${ACCOUNTING_BASE}/financial-years`} className="text-xs font-semibold uppercase tracking-[0.16em] text-[#6B7280] hover:text-[#111827]">
          &larr; Financial Years
        </Link>
        <h2 className="mt-1 text-lg font-extrabold text-[#111827]">{fy.code}</h2>
      </div>

      <SectionCard title="Financial year details">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <DetailField label="Start date" value={fy.startDate} />
          <DetailField label="End date" value={fy.endDate} />
          <div>
            <div className="text-xs uppercase tracking-[0.14em] text-[#6B7280]">Current</div>
            <div className="mt-1"><StatusPill active={!!fy.isCurrent} trueLabel="Yes" falseLabel="No" /></div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.14em] text-[#6B7280]">Status</div>
            <div className="mt-1"><StatusPill active={fy.status !== "locked"} trueLabel="Open" falseLabel="Locked" /></div>
          </div>
          <DetailField label="Vouchers in this year" value={fy.voucherCount} />
        </div>
        <p className="mt-4 text-xs text-[#6B7280]">Dates cannot be edited once a financial year is created, so posted vouchers can never be invalidated by a later date change.</p>
      </SectionCard>

      <SectionCard title="Record history">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <DetailField label="Created" value={fy.createdAt ? new Date(fy.createdAt).toLocaleString() : "-"} />
          <DetailField label="Created by" value={fy.createdBy} />
        </div>
      </SectionCard>
    </div>
  );
}
